import React, { useState } from "react";
import PropTypes from "prop-types";
import {
  Autocomplete,
  Box,
  Button,
  IconButton,
  Popover,
  TextField,
  Typography,
  Stack,
} from "@mui/material";
import FilterListIcon from "@mui/icons-material/FilterList";
import { StyledButton, StyledCancelButton } from "components/StyledComponents/styledComponents";

const FilterSection = ({
  businessStatusFilter,
  monthIdData,
  businessMonthID,
  setBusinessMonthID,
  serviceTypeCode,
  setServiceTypeCode,
  setBusinessStatusFilter,
  handleFilter,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  const statusOptions = [
    { label: "New", value: 0 },
    { label: "Added to MIS", value: 1 },
    { label: "MIS Sent", value: 2 },
    { label: "Partially Disbursed", value: 3 },
    { label: "Disbursed", value: 4 },
    { label: "Invoice Sent", value: 5 },
    { label: "Aborted", value: 21 },
  ];

  const serviceTypeOptions = [
    { label: "Loans", value: "BL" },
    { label: "Insurance", value: "IN" },
    { label: "Mutual Fund", value: "MF" },
  ];

  return (
    <Box>
      <StyledButton onClick={handleOpen} color="primary">
        <FilterListIcon /> Filter
      </StyledButton>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        PaperProps={{
          sx: {
            p: 2,
            width: "100%",
            maxWidth: "300px",
            backgroundColor: "#FFFFFF",
            boxShadow: 3,
            borderRadius: 2,
          },
        }}
      >
        <Typography variant="h6" gutterBottom>
          Filter Data
        </Typography>

        <Stack spacing={1.5}>
          <Autocomplete
            options={statusOptions}
            getOptionLabel={(option) => option.label}
            value={statusOptions.find((option) => option.value === businessStatusFilter) || null}
            onChange={(_, newValue) => setBusinessStatusFilter(newValue ? newValue.value : null)}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Business Status"
                variant="outlined"
                sx={{
                  height: 42,
                  "& .MuiInputBase-root": {
                    height: "100%",
                  },
                }}
                fullWidth
              />
            )}
          />

          <Autocomplete
            options={monthIdData}
            getOptionLabel={(option) => option.date || ""}
            value={monthIdData.find((item) => item.businessMonthID === businessMonthID) || null}
            onChange={(_, newValue) => setBusinessMonthID(newValue?.businessMonthID || "")}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Date"
                variant="outlined"
                sx={{
                  height: 42,
                  "& .MuiInputBase-root": {
                    height: "100%",
                  },
                }}
                fullWidth
              />
            )}
          />
          <Autocomplete
            options={serviceTypeOptions}
            getOptionLabel={(option) => option.label}
            value={serviceTypeOptions.find((option) => option.value === serviceTypeCode) || null}
            onChange={(_, newValue) => setServiceTypeCode(newValue?.value || "")}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Service Type"
                variant="outlined"
                sx={{
                  height: 42,
                  "& .MuiInputBase-root": {
                    height: "100%",
                  },
                }}
                fullWidth
              />
            )}
          />
          <Stack direction="row" spacing={1} justifyContent="flex-end">
            <StyledCancelButton onClick={handleClose}>Close</StyledCancelButton>
            <StyledButton
              onClick={() => {
                handleFilter();
                handleClose();
              }}
            >
              Apply
            </StyledButton>
          </Stack>
        </Stack>
      </Popover>
    </Box>
  );
};

// PropTypes for FilterSection
FilterSection.propTypes = {
  businessStatusFilter: PropTypes.number,
  handleStatusChange: PropTypes.func.isRequired,
  monthIdData: PropTypes.arrayOf(
    PropTypes.shape({
      date: PropTypes.string,
      businessMonthID: PropTypes.string,
    })
  ).isRequired,
  businessMonthID: PropTypes.string,
  setBusinessMonthID: PropTypes.func.isRequired,
  setBusinessStatusFilter: PropTypes.func.isRequired,
  serviceTypeCode: PropTypes.string,
  setServiceTypeCode: PropTypes.func.isRequired,
  handleFilter: PropTypes.func.isRequired,
};

export default FilterSection;
